import projectData from '../data/projectData';

const projectService = {
  getProjectsByUserId: async (userId) => {
    try {
      console.log('[DEBUG] Buscando proyectos para userId:', userId);
      const projects = await projectData.getProjectsByUserId(userId);
      console.log('[DEBUG] Proyectos encontrados:', projects.length);
      console.log('[DEBUG] Detalles de proyectos:', projects);
      return projects;
    } catch (error) {
      console.error('[ERROR] Error getting projects:', error);
      throw error;
    }
  },
  createProject: async (project) => {
    try {
      const projectWithDefaults = {
        ...project,
        isActivity: project.isActivity || false
      };
      const newProject = await projectData.createProject(projectWithDefaults);
      return newProject;
    } catch (error) {
      console.error('Error creating project:', error);
      throw error;
    }
  },
  deleteProject: async (projectId) => {
    try {
      await projectData.deleteProject(projectId);
    } catch (error) {
      console.error('Error deleting project:', error);
      throw error;
    }
  },
  updateProject: async (projectId, updateData) => {
    if (!projectId) {
      console.error("Update cancelled: Project ID is missing.");
      return; // No hace nada si el ID no está presente
    }
    try {
      const updatedProject = await projectData.updateProject(projectId, updateData);
      return updatedProject;
    } catch (error) {
      console.error("Error updating project:", error);
      throw error;
    }
  },
  

  getProjectById: async (userId, projectId) => {
    try {
      if (!projectId) {
        throw new Error('El ID del proyecto es indefinido o nulo');
      }

      const project = await projectData.getProjectById(userId, projectId);
      
      if (!project) {
        throw new Error(`Project with ID ${projectId} not found`);
      }
      
      // Verificar permisos
      console.log('[DEBUG] Verificando permisos:', {
        projectPermissions: project.permissions,
        projectOwnerId: project.ownerId,
        projectUserId: project.userId,
        requestingUserId: userId
      });

      // Verificar si el usuario tiene acceso por permissions o es el owner/userId
      const hasAccess = (project.permissions && project.permissions[userId]) || 
                       project.ownerId === userId || 
                       project.userId === userId;

      console.log('[DEBUG] ¿Usuario tiene acceso?:', hasAccess);

      if (!hasAccess) {
        console.warn('[WARN] Usuario sin acceso al proyecto');
        throw new Error(`User ${userId} does not have access to project ${projectId}`);
      }

      return project;
    } catch (error) {
      console.error('[ERROR] Error getting project by ID:', error);
      throw error;
    }
  },

  addComponentToProject: async (projectId, component) => {
    try {
      await projectData.addComponentToProject(projectId, component);
    } catch (error) {
      console.error('Error adding component to project:', error);
      throw error;
    }
  },
  // Nueva función para contar componentes
  async getNextAvailableComponentId(projectId, prefix) {
    try {
      // Obtener el siguiente ID disponible basado en el prefijo
      const nextId = await projectData.getNextAvailableComponentId(projectId, prefix);
      return nextId;
    } catch (error) {
      console.error('Error getting next available component ID:', error);
      throw error;
    }
  },

  removeComponentFromProject: async (projectId, idLocal) => {
    try {
        const result = await projectData.removeComponentFromProject(projectId, idLocal);

        if (result.success) {
            return result; // Confirmación de eliminación
        } else {
            throw new Error(`No se pudo eliminar el componente ${idLocal}`);
        }
    } catch (error) {
        console.error(`Error eliminando componente del proyecto ${projectId}:`, error);
        throw error;
    }
},
  uploadImageToProject: async (file) => {
    const url = await projectData.uploadImageToProject(file);
    return url;
  },
  removeConnectionsFromProject: async (projectId, connectionsToRemove) => {
    try {
      await projectData.removeConnectionsFromProject(projectId, connectionsToRemove);
    } catch (error) {
      console.error('Error removing connections from project:', error);
      throw error;
    }
  },
  async saveConnectionToDB(projectId, connection) {
    try {
      await projectData.saveConnectionToDB(projectId, connection);
      console.log('Connection saved successfully in Firestore.');
    } catch (error) {
      console.error('Error saving connection to Firestore:', error);
      throw error;
    }
  },
  shareProject: async (projectId, userEmail, permissionLevel) => {
    try {
      await projectData.addProjectPermission(projectId, userEmail, permissionLevel);
    } catch (error) {
      console.error('Error sharing project:', error);
      throw error;
    }
  }
};

export default projectService;
